export default {"src":"/_next/static/media/add_to_cart.28ec8922.svg","height":25,"width":25};